"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchCondition = _interopRequireDefault(require("01_core/components/layout/SearchCondition"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _authorityUtil = _interopRequireDefault(require("01_core/logics/authorityUtil"));
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _SelectKaisha = _interopRequireDefault(require("../../common/components/SelectKaisha"));
var _areaOrderingActions = require("../areaOrderingActions");
var _useRHFForm = require("01_core/validation/useRHFForm");
var Yup = _interopRequireWildcard(require("yup"));
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 地域表示順設定検索条件コンポーネント
 */
function AreaOrderingSearchCondition(props) {
  var _searchConditions$kai, _errors$kaishaCd;
  const {
    intl,
    callAPI,
    changeSearchCondition,
    openInfoBar,
    resetPaging,
    setSearchResult,
    searchConditions,
    fixedConditions,
    search,
    isReSearch,
    setIsReSearch,
    isNewWindow,
    pms,
    changeInitSearchCondtion,
    loginUserInfo,
    initCondtionComplete,
    callAPIShowCallingMessage
  } = props;
  const area = _react.default.useRef(null);
  const PERMISSIONS = {
    KAISHASOSHIKI_SELECT_ALL: 'kaishasoshiki:select:all_kaisha'
  };
  const isSetNone = _authorityUtil.default.hasPermission(pms, PERMISSIONS.KAISHASOSHIKI_SELECT_ALL);
  const schema = _react.default.useMemo(() => Yup.object({
    kaishaCd: !isSetNone ? (0, _validationHelpers.requiredSelect)(intl) : Yup.string().nullable()
  }), [isSetNone, intl]);
  const {
    handleSubmit,
    setValue,
    reset,
    formState: {
      errors
    }
  } = (0, _useRHFForm.useRHFForm)({
    shape: schema,
    defaultValues: {
      kaishaCd: (_searchConditions$kai = searchConditions.kaishaCd) !== null && _searchConditions$kai !== void 0 ? _searchConditions$kai : ''
    }
  });
  const didAutoSearchRef = _react.default.useRef(false);
  _react.default.useEffect(() => {
    callAPIShowCallingMessage(false);
    if (search && !isReSearch && !didAutoSearchRef.current) {
      didAutoSearchRef.current = true;
      onSearchClick();
    }
    if (initCondtionComplete) {
      // 初期処理としての検索条件が完了している場合は、スキップ
      return;
    }

    // 会社名：ログインユーザの会社を初期選択する。
    changeInitSearchCondtion('kaishaCd', loginUserInfo.kaishaCd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 検索ボタン押下時のハンドラ
  const searchingRef = _react.default.useRef(false);
  const onSearchClick = _react.default.useCallback(() => {
    if (searchingRef.current) return;
    searchingRef.current = true;
    let conditions = _objectSpread({}, searchConditions);
    if (!search) {
      resetPaging();
    }
    if (isReSearch) {
      // 並び順変更後の再検索の場合
      conditions = _objectSpread({}, fixedConditions);
      changeSearchCondition('kaishaCd', conditions.kaishaCd); // 前回の検索結果をSearchconditionに反映しておく
    }
    callAPI(_APIs.AREA_ORDERING_SEARCH, conditions).then(json => {
      if (Array.isArray(json.data.results) && json.data.results.length > 0) {
        setSearchResult(json.data.results);
        _windowUtil.default.scrollBelowElement(area.current);
      } else {
        setSearchResult([]);
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
          id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
        }));
      }
      setIsReSearch(false); // 再検索しないようにfalseに戻す
    }).catch(() => {}).finally(() => {
      searchingRef.current = false;
    });
  }, [searchConditions, search, resetPaging, isReSearch, fixedConditions, changeSearchCondition, callAPI, setSearchResult, openInfoBar, intl, setIsReSearch]);
  _react.default.useEffect(() => {
    if (isReSearch) {
      onSearchClick(); // 再検索を行う
    }
  }, [isReSearch, onSearchClick]);
  const onChangeKaisha = _ref => {
    let {
      kaishaCd
    } = _ref;
    changeSearchCondition('kaishaCd', kaishaCd);
    setValue('kaishaCd', kaishaCd !== null && kaishaCd !== void 0 ? kaishaCd : '', {
      shouldValidate: false,
      shouldDirty: false
    });
  };
  _react.default.useEffect(() => {
    var _searchConditions$kai2;
    reset({
      kaishaCd: (_searchConditions$kai2 = searchConditions.kaishaCd) !== null && _searchConditions$kai2 !== void 0 ? _searchConditions$kai2 : ''
    });
  }, [searchConditions.kaishaCd, reset]);
  const conditions = [/*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_COMPANY
    })
  }, /*#__PURE__*/_react.default.createElement(_SelectKaisha.default, {
    onChange: onChangeKaisha,
    value: searchConditions.kaishaCd,
    isSetNone: isSetNone,
    error: !!errors.kaishaCd,
    helperText: (_errors$kaishaCd = errors.kaishaCd) === null || _errors$kaishaCd === void 0 ? void 0 : _errors$kaishaCd.message
  }))];
  const closeBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => {
      window.close();
    },
    negative: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CLOSE
  }));
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onSearchClick, () => props.openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    })))
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: area
  }, isNewWindow ? /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
    conditions: conditions,
    validate: true,
    cancelBtn: closeBtn
  }) : /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
    conditions: conditions,
    validate: true,
    returnHome: true
  })));
}
const mapStateToProps = state => {
  return {
    searchConditions: state.areaOrdering.searchConditions,
    fixedConditions: state.areaOrdering.fixedConditions,
    isReSearch: state.areaOrdering.isReSearch,
    search: state.areaOrdering.search,
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    initCondtionComplete: state.areaOrdering.initCondtionComplete
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    changeInitSearchCondtion: (key, value) => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.CHANGE_INIT_SEARCH_CONDITION](key, value)),
    setSearchResult: results => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.SET_SEARCH_RESULT](results)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    resetPaging: () => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.RESET_PAGING]()),
    setIsReSearch: isReSearch => dispatch(_areaOrderingActions.areaOrderingActions[_areaOrderingActions.TYPES.SET_IS_RE_SEARCH](isReSearch))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(AreaOrderingSearchCondition))));